import { call, put, takeEvery } from "redux-saga/effects"
import { CandidateInterestFeedback, postCall } from "../../../../helpers/fakebackend_helper"
import { FINISH_ASSESSMENT_TEST, GET_ASSESSMENT_TEST_DETAILS, GET_ASSESSMENT_TEST_QUESTIONS } from "./actionTypes"
import { finishAssessmentTestFailed, finishAssessmentTestSuccess, getAssessmentTestDetailsFailed, getAssessmentTestDetailsSuccess, getAssessmentTestQuestionsFailed, getAssessmentTestQuestionsSuccess } from "./actions"
//restapi end point
import * as constClass from "../../../../common/constant/constantURL"
// submit feedback
function* getAssessmentDetailsHandler(data) {
    try {
      
    let url = constClass.REST_API_ASSESSMENT_TEST+`?code=${data.payload.code}`

    let responsJSON = yield call(CandidateInterestFeedback, url)
   
    yield put(getAssessmentTestDetailsSuccess(responsJSON))
  }
  catch (error) {
    yield put(getAssessmentTestDetailsFailed(error))
  }
}

function* finishTestHandler(data) {
    try {

    let url = constClass.REST_API_ASSESSMENT_TEST
    let responsJSON = yield call(postCall, url,data.payload)
    yield put(finishAssessmentTestSuccess(responsJSON))
  }
  catch (error) {
    yield put(finishAssessmentTestFailed(error))
  }
}

function* getAssessmentQuestionsHandler(data) {
  try {
    
  let url = constClass.REST_API_ASSESSMENT_TEST+`/questions?code=${data.payload.code}`

  let responsJSON = yield call(CandidateInterestFeedback, url)
  
  yield put(getAssessmentTestQuestionsSuccess(responsJSON))
}
catch (error) {
  yield put(getAssessmentTestQuestionsFailed(error))
}
}



function* AssessmentTestSaga() {
  yield takeEvery(GET_ASSESSMENT_TEST_DETAILS, getAssessmentDetailsHandler);
  yield takeEvery(FINISH_ASSESSMENT_TEST,finishTestHandler);
  yield takeEvery(GET_ASSESSMENT_TEST_QUESTIONS,getAssessmentQuestionsHandler);
}

export default AssessmentTestSaga